import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { XCircleIcon } from "@heroicons/react/24/outline";
import { addToCart, removeFromCart } from "store/features/cartSlice";

const CartModal = ({ item, onClose }) => {
  const dispatch = useDispatch();
  const [count, setCount] = useState(1);
  const totalPrice = count * item.price;

  return (
    <div
      className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-[50]"
      onClick={onClose}
    >
      <div
        className="relative p-8 bg-darkbg rounded-xl shadow-md max-w-lg m-2 z-[60] border border-border"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Close Button */}
        <button className="absolute top-5 right-4 text-xl" onClick={onClose}>
          <XCircleIcon className="max-w-[24px] w-full text-navy" />
        </button>

        {/* Modal Content */}
        <p className="text-[18px] font-semibold text-navy mt-5">{item.title}</p>
        <p className="text-sm sm:text-sm text-text">{item.desc}</p>

        {/* Quantity Section */}
        <div className="flex items-center justify-between rounded px-2 py-1 my-5">
          <legend className="text-sm text-text font-semibold">Quantity</legend>
          <div className="flex gap-1 items-center text-sm">
            <button
              className="px-3 py-1 hover:bg-gray-100 border border-navy rounded"
              onClick={() => setCount(Math.max(count - 1, 1))}
            >
              -
            </button>
            <p className="px-4 py-1 font-semibold">{count}</p>

            <button
              className="px-3 py-1 hover:bg-gray-100 border border-navy rounded"
              onClick={() => setCount(count + 1)}
            >
              +
            </button>
          </div>
        </div>

        {/* Total Price + Add */}
        <div className="flex justify-between items-center mt-2 p-2 rounded mt-5 min-w-[340px] ">
          <legend className="text-sm text-text font-semibold">Total</legend>
          <p className="ml-1 text-navy text-sm">${totalPrice.toFixed(2)}</p>
        </div>
        <div className="flex justify-end items-center gap-x-5 items-center mt-3 p-3 rounded mt-5 min-w-[340px] border-t">
          {" "}
          <button
            className="px-4 py-1 bg-navy rounded tracking-wide text-neonYellow text-xs uppercase animate-neonFlicker hover:bg-gray-600"
            onClick={() => {
              dispatch(addToCart({ item: { ...item, count } }));
              onClose(); // close modal after adding
            }}
          >
            Add +
          </button>
          <button
            className="text-xs mt-2 uppercase tracking-wide underline hover:text-red-500 transition"
            onClick={() => {
              dispatch(removeFromCart(item));
              onClose(); // close modal after adding
            }}
          >
            Remove
          </button>
        </div>
      </div>
    </div>
  );
};

export default CartModal;
